import { createContext, useContext, useState, type JSX, type ReactNode } from 'react';

interface BlockedAccountContextType {
  isAccountBlocked: boolean;
  setAccountBlocked: (blocked: boolean) => void;
}

const BlockedAccountContext = createContext<BlockedAccountContextType | undefined>(undefined);

interface BlockedAccountProviderProps {
  children: ReactNode;
}

export const BlockedAccountProvider = ({ children }: BlockedAccountProviderProps): JSX.Element => {
  const [isAccountBlocked, setIsAccountBlocked] = useState(false);

  const setAccountBlocked = (blocked: boolean) => {
    setIsAccountBlocked(blocked);
  };

  return (
    <BlockedAccountContext.Provider value={{ isAccountBlocked, setAccountBlocked }}>
      {children}
    </BlockedAccountContext.Provider>
  );
};

export const useBlockedAccount = (): BlockedAccountContextType => {
  const context = useContext(BlockedAccountContext);
  if (!context) {
    throw new Error('useBlockedAccount must be used within BlockedAccountProvider');
  }
  return context;
};
